import { PROJECTS_TAG } from '../../../../data/actions';
import { getProjectConditions, setProjectConditions } from '../projectActions';

export const CONDITIONS_TAG = 'Conditions';

export const invalidateConditions = () => {
  return dispatch => {
    dispatch(setProjectConditions(null));
  };
};

export const createConditionInProject = (condition, projectId, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    // condition.project_id = projectId;
    const conditionId = await apiClient.call(CONDITIONS_TAG, 'createCondition', {}, condition);

    await apiClient.call(
      PROJECTS_TAG,
      'associateProjectConditions',
      { projectId },
      { id: conditionId.id }
    );

    dispatch(getProjectConditions(projectId));

    callback && callback(conditionId.id);

    return true;
  };
};

export const updateCondition = (condition, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(
      CONDITIONS_TAG,
      'updateCondition',
      {
        id: condition.id
      },
      condition
    );

    dispatch(getProjectConditions(condition.project_id));

    callback && callback();

    return true;
  };
};

export const deleteCondition = (conditionId, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(CONDITIONS_TAG, 'deleteCondition', { id: conditionId });

    dispatch(getProjectConditions());

    callback && callback();

    return true;
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/experimentalDesign/conditionActions.js